import React from 'react';
import Topnavigation from './Topnavigation';
import Footer from './Footer';
import SEO from './SEO';

const services = [
  {
    img: './assets/img/class01.jpg',
    icon: '📚',
    title: 'SSC Coaching',
    desc: 'Comprehensive SSC coaching with expert faculty, structured study material, and regular mock tests to ensure top results.',
  },
  {
    img: './assets/img/class03.jpg',
    icon: '🔬',
    title: 'Science Batches',
    desc: 'Specialized Science batches covering Physics, Chemistry, and Biology with practical-oriented teaching methods.',
  },
  {
    img: './assets/img/class02.jpg',
    icon: '📊',
    title: 'Commerce Classes',
    desc: 'In-depth Commerce coaching covering Accounts, Economics, and Business Studies with real-world examples.',
  },
  {
    img: './assets/img/class00.jpg',
    icon: '📖',
    title: 'Study Material',
    desc: 'Well-curated, exam-focused study material prepared by experienced educators for all subjects and standards.',
  },
  {
    img: './assets/img/pens01.jpg',
    icon: '✍️',
    title: 'Test & Assessment',
    desc: 'Regular topic-wise tests, major tests, and detailed feedback to track student progress and improvement.',
  },
  {
    img: './assets/img/slideg05.jpg',
    icon: '🎯',
    title: 'Personal Attention',
    desc: 'Small batch sizes ensure every student gets personal attention and quick doubt resolution from teachers.',
  },
];

const features = [
  { icon: '🏆', title: '12+ Years Experience', desc: 'Over a decade of excellence in coaching education.' },
  { icon: '👨‍🏫', title: 'Expert Faculty', desc: 'Highly qualified and dedicated teaching staff.' },
  { icon: '📝', title: 'Regular Tests', desc: 'Frequent assessments to monitor student growth.' },
  { icon: '🌟', title: 'Proven Results', desc: 'Hundreds of successful students every year.' },
];

const OurServices = () => {
  return (
    <>
      <Topnavigation />
      <SEO
        title="Our Services - Coaching & Study Material"
        description="Study-Link provides SSC coaching, Science batches, Commerce classes, study material, tests & personal attention for students in Indore. Enroll today!"
        keywords="coaching services indore, study material indore, test series indore, personal coaching indore"
        url="/our-services"
      />

      {/* Hero Banner */}
      <div style={{ position: 'relative', marginTop: 0 }}>
        <img
          src="./assets/img/courses_offered.jpg"
          alt="Our Services"
          style={{ width: '100%', height: 'auto', maxHeight: 420, objectFit: 'cover' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'rgba(0,0,0,0.55)',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <h1 style={{ color: '#fff', fontWeight: 700, fontSize: 'clamp(24px, 5vw, 48px)', textAlign: 'center' }}>
            Our Services
          </h1>
          <p style={{ color: '#ddd', fontSize: 'clamp(14px, 2vw, 18px)', textAlign: 'center', maxWidth: 600, padding: '0 15px' }}>
            Empowering students with quality education since 2012
          </p>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ background: 'transparent', justifyContent: 'center' }}>
              <li className="breadcrumb-item"><a href="/" style={{ color: '#009999' }}>Home</a></li>
              <li className="breadcrumb-item active" style={{ color: '#fff' }}>Our Services</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Intro Section */}
      <section style={{ padding: '60px 0 30px', background: '#f9f9f9' }}>
        <div className="container text-center">
          <h2 style={{ color: '#009999', fontWeight: 700 }}>What We Offer</h2>
          <div style={{ width: 60, height: 3, background: '#009999', margin: '12px auto 20px' }}></div>
          <p style={{ maxWidth: 700, margin: '0 auto', color: '#555', fontSize: 16, lineHeight: 1.8 }}>
            At Study-Link Coaching Classes, we provide a wide range of educational services tailored
            to help students from 5th to 12th standard achieve academic excellence. Our experienced
            faculty and structured curriculum ensure every student reaches their full potential.
          </p>
        </div>
      </section>

      {/* Services Cards */}
      <section style={{ padding: '40px 0 60px', background: '#f9f9f9' }}>
        <div className="container">
          <div className="row">
            {services.map((s, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-4 mb-4">
                <div className="card h-100" style={{
                  border: 'none',
                  borderRadius: 10,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  overflow: 'hidden',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-6px)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,153,153,0.2)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  }}
                >
                  <div style={{ position: 'relative', overflow: 'hidden' }}>
                    <img
                      src={s.img}
                      alt={s.title}
                      style={{ width: '100%', height: 200, objectFit: 'cover', transition: 'transform 0.4s ease' }}
                      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    />
                    <div style={{
                      position: 'absolute', bottom: -20, left: 20,
                      width: 48, height: 48, borderRadius: '50%',
                      background: '#009999', display: 'flex',
                      alignItems: 'center', justifyContent: 'center',
                      fontSize: 22, boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                    }}>
                      {s.icon}
                    </div>
                  </div>
                  <div className="card-body" style={{ paddingTop: 30 }}>
                    <h5 style={{ fontWeight: 700, color: '#333', marginBottom: 10 }}>{s.title}</h5>
                    <p style={{ color: '#666', fontSize: 14, lineHeight: 1.7, marginBottom: 0 }}>{s.desc}</p>
                  </div>
                  <div style={{ padding: '0 20px 20px' }}>
                    <a href="/contact-us" style={{
                      color: '#009999', fontWeight: 600, fontSize: 14,
                      textDecoration: 'none', borderBottom: '2px solid #009999',
                    }}>
                      Enquire Now →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section style={{ padding: '60px 0', background: '#009999' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 style={{ color: '#fff', fontWeight: 700 }}>Why Choose Study-Link?</h2>
            <div style={{ width: 60, height: 3, background: '#fff', margin: '12px auto 0' }}></div>
          </div>
          <div className="row">
            {features.map((f, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
                <div className="text-center" style={{
                  background: 'rgba(255,255,255,0.12)',
                  borderRadius: 10, padding: '30px 20px',
                  border: '1px solid rgba(255,255,255,0.2)',
                }}>
                  <div style={{ fontSize: 40, marginBottom: 15 }}>{f.icon}</div>
                  <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: 10 }}>{f.title}</h5>
                  <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, marginBottom: 0 }}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '60px 0', background: '#fff' }}>
        <div className="container text-center">
          <h3 style={{ fontWeight: 700, color: '#333', marginBottom: 15 }}>
            Ready to Start Your Learning Journey?
          </h3>
          <p style={{ color: '#666', fontSize: 16, marginBottom: 30, maxWidth: 500, margin: '0 auto 30px' }}>
            Join hundreds of successful students at Study-Link Coaching Classes.
          </p>
          <a href="/contact-us" className="btn" style={{
            background: '#009999', color: '#fff',
            padding: '12px 40px', borderRadius: 6,
            fontSize: 16, fontWeight: 600,
            textDecoration: 'none', display: 'inline-block',
          }}>
            Contact Us Today
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default OurServices;
